export default {
  partner: {
    banner: {
      title:
        "Nouvelle batterie virtuelle en 2026 - Fournisseur d'énergie Ohm Energie lance nouvelle offre",
      button: "Découvrir conditions",
    },
    hero: {
      title: "Transformez vos chantiers en revenus",
      description:
        "Publiez vos cahier de charges sur la plateforme en ligne pour entrer en contact en toute sécurité avec des milliers d'installateurs locaux qualifiés. Gagnez des commissions avec gestion opérationnelle.",
      "button-1": "Inscription gratuite",
      "button-2": "Fonctionnement",
      "small-text":
        "Gratuit - Sans engagement - Contrôle total sur vos chantiers",
    },
    purpose: {
      title:
        "Conçu pour les entreprises qui commercialisent les énergies propres",
      description:
        "Gagnez des revenus sur votre portefeuille tout en gardant le contrôle avec une solution opérationnelle pour la pose et les démarches.",
      sections: {
        "sales-companies": {
          title: "Marque de confiance",
          description:
            "Vous identifiez et gérez les opportunités de vente, et souhaitez augmenter vos revenus à moindre coût.",
        },
        "project-developers": {
          title: "Constructeurs",
          description:
            "Vous avez de vrais clients et chantiers, mais vous avez besoin de poseurs locaux fiables pour les réaliser.",
        },
        "lead-generators": {
          title: "Régies commerciales",
          description:
            "Vous souhaitez des résultats de meilleure qualité et plus transparents, plutôt que de simples transferts de prospects.",
        },
      },
    },
    "how-it-works": {
      title: "Coment devenir un donneur d’ordres ?",
      steps: {
        step1: {
          title: "Définissez le cahier de charges",
          description:
            "Vous avez déjà une opportunité solaire. Résidentiel ou tertiaire, vous définissez la portée, les exigences et le calendrier.",
        },
        step2: {
          title: "Publiez en ligne",
          description:
            "Choisissez le mode de mise en relation en définissant les montants et conditions pour recevoir des offres qualifiées.",
        },
        step3: {
          title: "Gagnez du chiffre d'affaires",
          description:
            "Choisissez le poseur qui correspond à vos critères. Le chantier avance et vous gagnez en commissions, sans risque opérationnel.",
        },
      },
    },
    benefits: {
      title: "Une façon plus intelligente de monétiser les opérations",
      items: {
        item1: "Opérations sans interface et transparentes",
        item2: "Contrôle des prix, des délais et des conditions",
        item3: "Gagnez des commissions sans embaucher",
        item4: "Accédez à un réseau national d'installateurs ",
        item5: "Offres transparentes et prix compétitifs",
      },
    },
    projects: {
      title: "Un marché avec de vrais chantiers",
      description:
        "Les installateurs peuvent les consulter, les évaluer et soumettre leurs offres en toute transparence.",
      "button-1": "Rejoignez le marché",
    },
    cta: {
      title: "Commencez dès aujourd'hui à vendre",
      features: {
        feature1: "Gratuit",
        feature2: "Sécurisé",
        feature3: "Sans engagement",
      },
      "button-1": "Inscription",
    },
  },
  header: {
    home: "Accueil",
    solutions: "Solutions",
    "case-studies": "Études de cas",
    hardware: "Matériel",
    leads: "Prospects",
  },
  home: {
    title: "La plateforme d'appels d'offres du solaire et du stockage",
    description:
      "Feuilletez les chantiers solaires et de stockage actuellement en cours dans toute la France. Candidatez en tant que maître d'oeuvre aux appels d'offres réels, publiés par les maîtres d'ouvrage, partenaires commerciaux, et donneurs d'ordres.",
    "become-sales-partner": "Devenir donneur d'ordres",
    empty: {
      title: "Aucun chantier trouvé",
      description:
        "Aucun appel d'offres ne correspond aux filtres sélectionnés. Modifiez vos critères de recherche ou supprimez certains filtres.",
      reset: "Réinitialiser les filtres",
      view: "Voir tous les chantiers",
    },
  },
  card: {
    live: "En direct",
    offers: "offres",
    "estimated-power": "Puissance estimée",
    installation: "Installation",
    "view-specification": "Voir les spécifications",
    "project-types": {
      roof: "Toit",
      "ground-mount": "Au sol",
      carport: "Abri voiture",
      pergola: "Pergola",
      "flat-roof": "Toit plat",
    },
  },
  cta: {
    title: "Transformez vos chantiers solaires en revenus sans installation",
    description:
      "Si vous générez des opportunités solaires mais ne réalisez pas d'installations, Projet Solaire vous permet de publier vos chantiers, de choisir l'installateur et de percevoir une commission sans aucun risque lié à l'exécution.",
    benefits: {
      commission: "Gagnez des commissions sur des chantiers solaires concrets",
      control: "Gardez le contrôle sur les prix et le choix de l'installateur",
      "no-risk": "Aucun travail d'installation ni risque opérationnel",
      projects:
        "Convient aux chantiers résidentiels, commerciaux et industriels",
    },
    "become-partner": "Devenir donneur d'ordres",
    "see-how": "Découvrez comment ça marche",
  },
  filters: {
    "filter-by-department": "Filtrer par département",
    "filter-by-project-type": "Filtrer par type de chantier",
    "sort-by-date": "Trier par date (le plus urgent)",
    "clear-all": "Tout effacer",
    "department-label": "Département",
    "project-type-label": "Type de chantier",
    "project-types": {
      commercial: "Commercial",
      industrial: "Industriel",
      "public-authority": "Autorité publique",
    },
    sort: {
      "most-urgent": "Trier par date (le plus urgent)",
      newest: "Plus récent d'abord",
      oldest: "Plus ancien d'abord",
    },
  },
  "tender-details": {
    "project-information": "Informations sur le chantier",
    location: "Localisation",
    "published-date": "Date de publication",
    "fixed-price": "Prix fixe",
    "be-next": "Soyez le prochain",
    "create-an-account": "Créer un compte",
    "log-in-to-see-project-details":
      "Se connecter pour voir les détails du chantier",
  },
  tenders: {
    project: {
      "no-images": "Aucune image ajoutée par l'organisateur",
      overview: {
        "estimated-power": "Puissance estimée",
        faq: {
          "questions-frequents": "Questions fréquentes sur les conditions",
          "quoting-guidelines": {
            title: "Sous réserve de la visite technique",
            description:
              "Vous soumettez votre proposition chiffrée à partir du dossier technique. Le devis définitif n'est émis qu'après la visite obligatoire de faisabilité technique. Celle-ci est planifiée uniquement après que l'utilisateur a choisi votre proposition en fonction de votre chiffrage et de votre profil. Si la visite technique est facturée, elle devra être réglée au préalable par l'utilisateur (sans devis), et la facture apparaîtra sur votre compte.",
          },
          "cancellation-policy": {
            title: "Chiffrage modifiable à tout moment",
            description:
              "Votre proposition n'est pas un devis ; l'utilisateur restant anonyme votre chiffrage n'est donc pas un devis conforme engageant. Attention ! L'utilisateur n'a pas d'engagements en choisissant votre proposition ; notamment si le prix de votre devis définitif est largement supérieur à votre chiffrage initial. Une exception : si la visite technique est facturée, l'utilisateur devra payer votre montant pour pouvoir la planifier.",
          },
          "payments-information": {
            title: "Échéancier des paiements en ligne",
            description:
              "Vous fixez l'acompte et le solde de votre prix. Afin de faciliter l'expérience de nos utilisateurs, vous ne pouvez pas réaliser plusieurs acomptes. Vous pouvez facturer votre visite technique à l'utilisateur, que vous percevez dès la planification de la visite. Nos frais de service son facturés au règlement de l'acompte par votre client. Vous percevez automatiquement les virements directement sur votre compte bancaire.",
          },
        },
      },
      information: {
        installation: {
          title: "Information installation",
          "service-type-provided": "Type de prestation",
          municipality: "Commune",
          department: "Département",
          "estimated-installation-date": "Date d'installation prévue",
          "estimated-duration": "Durée estimée",
          days: "jours",
        },
        "technical-visit": {
          title: "Politique de visite technique",
          inspection: "Visite technique",
          "cost-of-inspection": "Montant de la visite technique",
          "not-tempted": "Pas tenté",
          "visit-not-required": "Visite non requise",
        },
        equipment: {
          "material-title": "Équipement matériel",
          "equipment-provided-by-organiser":
            "Le matériel ci-dessous sera fourni par l'organisateur sur place.",
          "selected-equipment": "Équipement sélectionné",
          "hardware-purchase-order-available":
            "Bon de commande de matériel disponible",
          "select-your-equipment": "Sélectionnez votre équipement",
        },
        organiser: {
          title: "Organisateur",
          "project-published-by-other-installer":
            "Chantier publié par un autre installateur",
          "accept-the-partner": "Accepte les CGU du partenaire",
        },
        installer: {
          title: "Donneur d'ordres",
          "pv-company": "Chantier publié par une autre entreprise PV.",
          "terms-and-conditions": "CGU du donneur d'ordres",
        },
        description: {
          title: "Description",
        },
        certification: {
          title: "Certification requise",
          "certification-required": "Existe une exigence de certification",
        },
      },
    },
    "hardware-purchase-order": {
      heading: "Matériel",
      title: "Souhaitez-vous associer un achat de matériel à cet éngagement?",
      "sub-title":
        "Choisissez ci-dessous si vous souhaitez inclure un achat de matériel dans votre chantier.",
      alert: {
        title:
          "En associant un achat de matériel, vous obligez l’installateur à acheter ces matériaux auprès de vous.",
      },
      tooltip:
        "Vous ne pouvez associer un bon de commande que si vous avez un compte Fournisseur pour l'Entrepôt",
      equipment: "Équipement matériel",
      hardware: {
        material: "Matériel",
        "update-price": "Mettre à jour le prix",
        purchase: {
          title: "Achat de matèriel",
          description: "Mettre à jour le prix pour vos matèriel.",
        },
        "add-an-offer": "Ajouter un offre",
        table: {
          manufacturer: "Fabricant",
          "model-name": "Modèle",
          qty: "Qté",
          "number-in-stock": "Quantité en stock",
          allocated: "Quantité alloué",
          price: "Prix",
          required: "Requis",
          selected: "Sélectionné",
          select: "Sélectionner",
          toggle: {
            panels: "Modules",
            inverters: "Onduleurs",
            "service-panels": "Tableaux électriques",
            "load-centers": "Disjoncteurs",
            "mounting-systems": "Systèmes de fixation",
            "combiner-boxes": "Boîtes de combinaison",
            "dc-optimisers": "Optimiseurs DC",
            batteries: "Batteries",
            disconnects: "Coffrets AC/DC",
            tiles: "Tuiles solaires",
            accessories: "Accessoires",
            "thermal-sensors": "Panneaux thermiques",
          },
          "no-hardware": "Ajouter votre équipement matériel",
          "no-hardware-description":
            "Aucun matériel n’a encore été enregistré.",
        },
        product: {
          power: "Puissance",
          type: "Type",
          "number-of-phases": "Nombre de phases",
          from: "à partir de",
          unit: "unité",
          "see-the-offers": "Voir les offres",
          Quantity: "Quantité",
          pieces: "Pièces",
          "delivery-cost": "Frais livraison",
          remove: "Rétirer",
        },
        "product-offer": {
          title: "Achat de matèriel",
          description: "Mettre à jour le prix pour vos matèriel",
          "offers-available": "Offres disponible",
          "add-an-offer": "Ajouter un offre",
          power: "Puissance",
          kind: "Type",
          "number-of-phases": "Nombre de phases",
          "pcs-available": "pcs disponible",
          price: "Prix",
          unit: "unité",
          choose: "Choisir",
          choosen: "choisie",
        },
      },
    },
  },
  breadcrumb: {
    "go-back": "Retour au marché",
    "tender-details": "Détails du chantier",
  },
}
